import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import {
  displayMarineValue,
  displayMarineValueWithUnit,
  joinMarineValues,
} from '../../../utils/marineForecast.utils';

export const route = 'getDetailedMarine7';

export const waveDetails = [
  {
    id: 'waveHeight',
    label: 'Wave Height',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WAVE,
    getValue: (entry) => displayMarineValueWithUnit(entry?.wave_height, ' ft'),
  },
  {
    id: 'meanWaveDirectionPeriod',
    label: 'Mean Wave Dir./Period',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_DIRECTION,
    getValue: (entry) =>
      joinMarineValues([
        entry?.mean_wave_direction_short,
        displayMarineValueWithUnit(entry?.mean_wave_period, ' sec'),
      ]),
  },
  {
    id: 'windWaveDirectionPeriod',
    label: 'Wind Wave Dir./Period',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WATER,
    getValue: (entry) =>
      joinMarineValues([
        entry?.wind_wave_direction_short,
        displayMarineValueWithUnit(entry?.wind_wave_period, ' sec'),
      ]),
  },
  {
    id: 'peakWaveDirectionPeriod',
    label: 'Peak Wave Dir./Period',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WAVE,
    getValue: (entry) =>
      joinMarineValues([
        entry?.peak_wave_direction_short,
        displayMarineValueWithUnit(entry?.peak_wave_period, ' sec'),
      ]),
  },
];

export const windDetails = [
  {
    id: 'windSpeedDirection',
    label: 'Wind Speed & Direction',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (entry) => joinMarineValues([entry?.wind_speed, entry?.wind_short]),
  },
  {
    id: 'windGusts',
    label: 'Wind Gusts',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_DIRECTION,
    getValue: (entry) => displayMarineValue(entry?.wind_gusts),
  },
  {
    id: 'beaufortDescription',
    label: 'Beaufort Description',
    iconKey: WEATHER_DETAIL_ICON_KEYS.ALERT,
    getValue: (entry) => displayMarineValue(entry?.beaufort_desc),
  },
  {
    id: 'seaSurfaceTemp',
    label: 'Sea Surface Temp',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TEMPERATURE,
    getValue: (entry) => displayMarineValueWithUnit(entry?.sea_surface_temp, '\u00b0F'),
  },
];
